<div class="main-body mt-5 pb-5">
    <div class="d-flex flex-column w-100">
      <div class="custom_heading1 mb-2">
        <span>Master Questions</span>
      </div>
    </div>
    <div class="table-title">
      <span>List of Technologies</span>
    </div>
    <!-- accordians  -->
    <div *ngFor="let technology of technologies">
      <mat-accordion>
        <!-- mb-2 when accordian opened -->
        <mat-expansion-panel class="mb-2" (opened)="getQuestions(technology.id)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{technology.description}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-table [dataSource]="dataSourceMap.get(technology.id)" matSort>
            
            <ng-container matColumnDef="Category">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Category </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <ng-container *ngIf="row.isEditMode; else textMode">
                  <mat-select [(ngModel)]="row.CategoryId" (selectionChange)="onCategoryChange(row.CategoryId)">
                    <mat-option *ngFor="let Category of categories" [value]="Category.id">
                      {{ Category.description }}
                    </mat-option>
                  </mat-select>
                </ng-container>
                <ng-template #textMode>
                  <span>{{ row.Category }}</span>
                </ng-template>
              </mat-cell>
            </ng-container>
            
            <ng-container matColumnDef="SubCategory">
              <mat-header-cell *matHeaderCellDef mat-sort-header class=""> SubCategoryName </mat-header-cell>
              <mat-cell *matCellDef="let row" class="">
                <ng-container *ngIf="row.isEditMode; else textMode">
                  <mat-select [(ngModel)]="row.SubcategoryId" (selectionChange)="onSubCategoryChange(row.CategoryId, row.SubcategoryId)" class="">
                    <mat-option *ngFor="let subcategory of subCategories" [value]="subcategory.id">
                      {{ subcategory.description }}
                    </mat-option>
                  </mat-select>
                </ng-container>
                <ng-template #textMode>
                  <span>{{ row.SubCategoryName }}</span>
                </ng-template>
              </mat-cell>
            </ng-container>
            
            <ng-container matColumnDef="Question">
              <mat-header-cell *matHeaderCellDef mat-sort-header class=""> Question </mat-header-cell>
              <mat-cell *matCellDef="let row" class="">
                  <ng-container *ngIf="row.isEditMode; else textMode">
                  <mat-select [(ngModel)]="row.Questionid" class="">
                    <mat-option *ngFor="let question of questions" [value]="question.id">
                      {{ question.description }}
                    </mat-option>
                  </mat-select>
                  </ng-container>
                  <ng-template #textMode>
                  <span> {{ row.Question }} </span>
                  </ng-template>
              </mat-cell>
            </ng-container>
            
            <ng-container matColumnDef="Weightage">
              <mat-header-cell *matHeaderCellDef mat-sort-header class=""> Weightage </mat-header-cell>
              <mat-cell *matCellDef="let row" class="">
                <span> {{ row.Weightage }} </span>
              </mat-cell>
            </ng-container>
            
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef class=""> Actions </mat-header-cell>
              <mat-cell *matCellDef="let row" class="">
                <button *ngIf="!row.isEditMode" class="custom_button1" (click)="editRow(row)">
                  Edit
                </button>
                <button *ngIf="row.isEditMode" class="custom_button1" (click)="Save(row, technology.id)">Save</button>
                <button *ngIf="!row.isEditMode" class="custom_button1" (click)="deleteRow(row.QuestionMappingId, technology.id)">
                  Delete
                </button>
                <!--need to put on some validations not to loose data -->
                <button *ngIf="row.isEditMode" class="custom_button1" (click)="Cancel(row)">Cancel</button>
              </mat-cell>
            </ng-container>
            
            <mat-header-row *matHeaderRowDef="displayedColumns" class="table-header"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
          
          <div class="quick-link col p-0" >
            <button class="custom_button" (click)="addNewRow(technology.id)">+ Add New Question</button>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>